export default __webpack_public_path__ + "static/media/sn.f895f490.svg";